import React from "react";
import { Container, Modal } from "reactstrap";

import Btn from "./Button";

const ConfirmModal = ({
  isOpen,
  onConfirm,
  onDeny,
  confirmLabel,
  denyLabel,
  message,
  sameButtons,
  verticalAlign,
  customStyle,
}) => {
  const containerClasses = ["confirm-modal"];

  if (verticalAlign) {
    containerClasses.push("vertical-align");
  }
  return (
    <Modal centered={true} isOpen={!!isOpen}>
      <Container
        style={customStyle?.container ? { ...customStyle.container } : {}}
        className={containerClasses.join(" ")}
      >
        <div className="confirm-modal-title">{message}</div>
        <div
          style={customStyle?.btn_container ? { ...customStyle.btn_container } : {}}
          className="confirm-modal-buttons"
        >
          <Btn
            label={denyLabel}
            type={"button"}
            style={customStyle?.btn_deny ? { ...customStyle.btn_deny } : {}}
            className={sameButtons ? "primary" : "secondary"}
            onClick={onDeny}
          />
          <Btn
            label={confirmLabel}
            type={"button"}
            style={customStyle?.btn_confirm ? { ...customStyle.btn_confirm } : {}}
            onClick={onConfirm}
          />
        </div>
      </Container>
    </Modal>
  );
};

export default ConfirmModal;
